<template>
    <div class="form-group" :class="{ 'has-error': hasError }">
        <label for="treatment">{{ trans('apps.treatments.short_name') }}</label>
        <select
            id="treatment"
            name="treatment"
            class="form-control"
            :value="value"
            :disabled="disabled"
            @input="$emit('input', $event.target.value ? $event.target.value : null)"
        >
            <option value="">
                {{ trans('apps.treatments.select_treatment') }}
            </option>

            <template v-if="groupByStatus">
                <optgroup
                    v-for="group in groupedTreatmentOptions"
                    :label="trans('apps.treatments.statuses.' + group.status)"
                >
                    <TreatmentSelectorOption
                        v-for="treatment in group.items"
                        :key="treatment.id"
                        :treatment="treatment"
                    />
                </optgroup>
            </template>
            <template v-else>
                <TreatmentSelectorOption
                    v-for="treatment in treatmentOptions"
                    :key="treatment.id"
                    :treatment="treatment"
                />
            </template>
        </select>
        <span v-show="hasError" class="help-block">
            {{ error }}
        </span>
    </div>
</template>

<script>
import TreatmentSelectorOption from 'Components/apps/treatments/TreatmentSelectorOption.vue';

const OPTION_SIZE = 60;

export default {
    components: {
        TreatmentSelectorOption
    },
    props: {
        value: {
            required: false,
            default: null,
        },
        treatments: {
            type: Array,
            required: true,
        },
        showAppointments: {
            type: Boolean,
            default: true,
        },
        groupByStatus: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
            default: null
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        treatmentOptions() {
            return this.treatments.map(treatment => ({
                ...treatment,
                treatment_type_formatted: treatment.treatment_type.length > OPTION_SIZE
                    ? `${treatment.treatment_type.substring(0, OPTION_SIZE)}...`
                    : treatment.treatment_type,
            }));
        },

        groupedTreatmentOptions() {
            let groups = {};

            for (const treatment of this.treatmentOptions) {
                if (!groups[treatment.status_sort_order]) {
                    groups[treatment.status_sort_order] = {
                        status: treatment.status,
                        items: [],
                    }
                }

                groups[treatment.status_sort_order].items.push(treatment);
            }

            return groups;
        }
    }
};
</script>
